import {
  DayTrade,
  BalanceInput,
  DrawdownInput,
  Review,
  HandleError
} from '../components';

export enum EMarginAllocationSteps {
  DAY_TRADE,
  BALANCE,
  DRAWDOWN,
  REVIEW,
  ERROR
}

export const MarginAllocationComponents = {
  [EMarginAllocationSteps.DAY_TRADE]: DayTrade,
  [EMarginAllocationSteps.BALANCE]: BalanceInput,
  [EMarginAllocationSteps.DRAWDOWN]: DrawdownInput,
  [EMarginAllocationSteps.REVIEW]: Review,
  [EMarginAllocationSteps.ERROR]: HandleError
};
